import React, { HTMLAttributes } from 'react';
import { SxProps } from '@mui/material';
import StyledMainContentInnerHtml from './styled';

interface PropsType extends HTMLAttributes<HTMLDivElement> {
	text: string;
	sx?: SxProps;
}

function MainContentInnerHtml({ text, sx, ...props }: PropsType) {
	return (
		<StyledMainContentInnerHtml
			sx={sx}
			dangerouslySetInnerHTML={{ __html: text }}
			{...props}
			className="ck-content"
		/>
	);
}

export default MainContentInnerHtml;
